// get client fait account currency.
export const GetClientFiatAccountCurrencies = (currency_id) => {
  const currencies = JSON.parse(localStorage.getItem("currencies") || "{}");
  const currency = currencies.find((c) => c.id === currency_id);
  return currency;
};

// get client fait account currency.
export const GetClientCryptoAccountCurrencies = (currency_id) => {
  const clientInfo = JSON.parse(localStorage.getItem("clientInfo") || "{}");
  const accounts = clientInfo.crypto_accounts || [];
  return accounts.find((account) => account.currency_code === currency_id);
};

// check if the client have a specific currency account.
export const isClientHaveThisCurrencyAccount = (currency_id) => {
  const clientInfo = JSON.parse(localStorage.getItem("clientInfo") || "{}");
  const accounts = clientInfo.accounts || [];
  return accounts.some((account) => account.currency_id === currency_id);
};
